import React, { useEffect } from 'react';
import { Forms, Loading, Paging, SystemText } from 'e4shared';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import FileLink from 'components/general/fileLink';
import { extension } from 'components/general/assets';
import { Card } from '../shared';

export const Pitchback = ({ allowMultiple, pageSize, onAddItem, noResultsMessage, testId }) => {
    const [pitchbackTasks, setPitchbackTasks] = React.useState([]);
    const [task, setTask] = React.useState(null);
    const [person, setPerson] = React.useState(null);
    const [competency, setCompetency] = React.useState(null);
    const [page, setPage] = React.useState(1);
    const [recordCount, setRecordCount] = React.useState(0);
    const [peopleMapped, setPeopleMapped] = React.useState([]);
    const [competenciesMapped, setCompetenciesMapped] = React.useState([]);
    const [tasksMapped, setTasksMapped] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    useEffect(() => {
        setPage(1);
    }, [task, person, competency]);

    useEffect(() => {
        apiGet(
            `pitchback-tasks?page=${page}&pagesize=${pageSize}&sort=name&sortdirection=asc&task=${task}&person=${person}&competency=${competency}`,
            guid,
            response => {
                setPitchbackTasks(response.results);
                setPeopleMapped(response.people);
                setCompetenciesMapped(response.competencies);
                setTasksMapped(response.tasks);
                setRecordCount(response.records);
                setLoading(false);
            }
        );
    }, [guid, page, task, person, competency]);

    if (loading)
        return (
            <div data-testid="loading">
                <Loading />
            </div>
        );

    return (
        <div data-testid={testId}>
            <div>
                <Forms.Select
                    id="filter-objectives"
                    label={SystemText('Admin/Forms/FilePicker/Content/Pitchback/Filters/Title')}
                    placeholder={SystemText('Admin/Forms/FilePicker/Content/Pitchback/Fields/Objectives/Placeholder')}
                    data={tasksMapped}
                    value={task}
                    onChange={x => setTask(x)}
                />
            </div>
            <div className="no-label">
                <Forms.Select
                    key="filter-people"
                    placeholder={SystemText('Admin/Forms/FilePicker/Content/Pitchback/Fields/People/Placeholder')}
                    data={peopleMapped}
                    value={person}
                    onChange={x => setPerson(x)}
                />
            </div>
            <div className="no-label">
                <Forms.Select
                    placeholder={SystemText('Admin/Forms/FilePicker/Content/Pitchback/Fields/Competencies/Placeholder')}
                    data={competenciesMapped}
                    value={competency}
                    onChange={x => setCompetency(x)}
                />
            </div>
            {!pitchbackTasks?.length ? (
                <div>{noResultsMessage}</div>
            ) : (
                <div>
                    <label>{SystemText('Admin/Forms/FilePicker/Content/Pitchback/Title')}</label>
                    <div className="text-sm mb5">{SystemText('Admin/Forms/FilePicker/Content/Pitchback/SubTitle')}</div>
                    <div className="list">
                        {pitchbackTasks.map((t, i) => (
                            <Card
                                addItemHandler={() => onAddItem(t, allowMultiple)}
                                title={SystemText('Admin/Forms/FilePicker/Content/Pitchback/Card/Title', t.name)}
                                label={t.name}
                                name={t.assigned_Fullname}
                                date={t.date_Completed}
                                key={`${t.id}-${t.profile_Id}`}
                            >
                                <FileLink
                                    key={`${t.profile_Id}-${t.id}`}
                                    folder="t_Completion"
                                    file={{
                                        ...t.completed_Video_Asset,
                                        video: true,
                                        ext: extension(t.completed_Video_Asset),
                                    }}
                                />
                            </Card>
                        ))}
                    </div>
                    {pitchbackTasks.length > 0 && (
                        <Paging pageSize={pageSize} recordCount={recordCount} page={page} goToPage={page => setPage(page)} />
                    )}
                </div>
            )}
        </div>
    );
};

export default Pitchback;
